import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { getAllTranslations } from "./utils/loadTranslations.js";

// Load all translations using the new modular structure
const resources = getAllTranslations();

i18n.use(initReactI18next).init({ resources, lng: "en" });

export default i18n;
